module.exports = __webpack_public_path__ + "static/media/IMG_2532-2.02a9c69e.jpg";